'use client'

import { useCurrentLanguage } from './useCurrentLanguage'
import { getTranslations, type Translations } from './translations'

export function useTranslations(): Translations {
    const currentLanguage = useCurrentLanguage()
    return getTranslations(currentLanguage.code)
}

// Хук для получения конкретной секции переводов
export function useTranslationsSection<T extends keyof Translations>(section: T): Translations[T] {
    const translations = useTranslations()
    return translations[section]
}

// Хук для получения переводов с функцией t для удобства
export function useT() {
    const translations = useTranslations()
    
    // Функция для получения перевода по пути (например, "common.cart")
    const t = (path: string): string => {
        const keys = path.split('.')
        let value: any = translations
        
        for (const key of keys) {
            if (value && typeof value === 'object' && key in value) {
                value = value[key]
            } else {
                console.warn(`Translation key "${path}" not found`)
                return path // Возвращаем исходный ключ если перевод не найден
            }
        }
        
        return String(value)
    }
    
    return { t, translations }
} 